module.exports = __webpack_public_path__ + "img/bg2.5f9f4326.jpg";